import { Hint, Label } from 'components';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { connect } from 'react-redux';

import { removeExcludedRange } from './_actions';
import { getExcludedRanges, getTotalColumns, getTotalRows } from './_selectors';
import { rangeToString } from './_utils';

interface IExcluder {
  excludedRanges: {
    column: number;
    row: number;
    start: number;
    end: number;
  }[];
  totalColumns: number;
  totalRows: number;
  removeExcludedRange: any;
}

const Excluder: FC<IExcluder> = ({
  excludedRanges,
  totalColumns,
  totalRows,
  removeExcludedRange
}) => {
  const t = useTranslations();

  return (
    <div className="mb-3">
      <Label>{t('ordering_form.exclude.excluded_cell_range')}</Label>
      <br />
      {!excludedRanges.length && <Hint className="mb-3">{t('ordering_form.exclude.how_to')}</Hint>}

      {excludedRanges.length > 0 &&
        excludedRanges.map((range, index) => {
          const key = `excluder-excluded-${index}--${range.column}-${range.row}`;

          return (
            <li
              key={key}
              id={key}
              className="ordering_form__excluder__excluded__range !bg-primary-red-100"
            >
              {rangeToString(range, totalRows, totalColumns, t)}
              <span
                className="ticon-cancel ordering_form__excluder__excluded__remove !mt-[2px] !pl-1"
                onClick={() => removeExcludedRange(index)}
              />
            </li>
          );
        })}
    </div>
  );
};

export default connect(
  (state) => ({
    excludedRanges: getExcludedRanges(state),
    totalColumns: getTotalColumns(state),
    totalRows: getTotalRows(state)
  }),
  { removeExcludedRange }
)(Excluder);
